export default __webpack_public_path__ + "static/media/NeueMontreal-BoldItalic.ad7e1beb.otf";